import React from 'react';

import Label from 'components/form/Label/Label';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { ReactComponent as LightBulbFilled } from 'style/icons/lightbulb-on-filled.svg';
const PaymentHistoryCreditScoreMessage = ({ showHideModal }) => {
  return (
    <>
      <FlexContainer className="margTopN10 padlr16">
        <LightBulbFilled className="width40px height40px" />
        <div>
          <Label type="Body-2 margb10" className="margl8 padt12">
            Payment history makes up 40% of your score and is a major factor in
            its calculation.
          </Label>

          <Label
            onClick={showHideModal}
            type="Body-2 pointer fontBlue100"
            className="margl8"
          >
            How is this calculated?
          </Label>
        </div>
      </FlexContainer>
    </>
  );
};

export default PaymentHistoryCreditScoreMessage;
